/**
 * Добавление классов к элементу
 * @param element
 * @param className
 * @param isString
 */
function addClass(element, className, isString = false) {
	if (className) {
		if (typeof className === 'string') {
			className = className.split(' ');
		}

		if (isString) {
			return '' + className.join(' ');
		}

		if (element) {
			element.classList.add(...className);
		}
	}
}

/**
 * Удаление классов
 * @param element
 * @param className
 */
function removeClass(element, className) {
	if (className && element) {
		if (typeof className === 'string') {
			className = className.split(' ');
		}

		element.classList.remove(...className);
	}
}

/**
 * Есть класс у элемента
 * @param element
 * @param className
 * @returns {boolean}
 */
function hasClass(element, className) {
	return element.classList.contains(className);
}

export function toggleClass(element, className) {
	if (hasClass(element, className)) {
		removeClass(element, className);
	} else {
		addClass(element, className);
	}
}

/**
 * Удаление элемента
 * @param element
 */
function removeElement(element) {
	if (!element) return false;
	element.parentNode.removeChild(element);
}

/**
 * Обвертка элемента
 * @param element
 * @param className
 * @param tag
 */
function wrap(element, className, tag = 'div') {
	const wrapper = document.createElement(tag);
	addClass(wrapper, className);

	let cloneElement = element.cloneNode(true);
	wrapper.appendChild(cloneElement);

	element.insertAdjacentHTML('beforebegin', wrapper.outerHTML);

	removeElement(element);
}

/**
 * Вытаскиваем все дата атрибуты у элемента
 * @param node
 * @param isRemoveDataName
 * @returns {{}}
 */
function getDataAttributes(node, isRemoveDataName = false) {
	if (!node) return false;

	let obj = {},
		arr = [].filter.call(node.attributes, function (at) {
			return /^data-/.test(at.name);
		});

	if (arr.length) {
		arr.forEach(function (v) {
			let name = v.name;
			if (isRemoveDataName) name = name.slice(5);
			obj[name] = v.value
		});
	}

	return obj;
}

/**
 * Определяем позицию элемента
 * @param element
 * @param parent
 * @returns {{}}
 */
function getElementPosition(element, parent) {
	if (typeof element === 'string') {
		element = document.querySelector(element);
	}

	if (parent) {
		if (typeof parent === 'string') {
			parent = document.querySelector(parent);
		}
	} else {
		parent = document.body;
	}

	let parentPosition = parent.getBoundingClientRect(),
		childPosition = element.getBoundingClientRect(),
		relativePos = {};

	relativePos.top    = childPosition.top - parentPosition.top;
	relativePos.right  = childPosition.right - parentPosition.right;
	relativePos.bottom = childPosition.bottom - parentPosition.bottom;
	relativePos.left   = childPosition.left - parentPosition.left;

	return relativePos;
}


/**
 * Скрыт ли элемент
 * @param el
 * @returns {boolean}
 */
function isHidden(el) {
	let style = window.getComputedStyle(el);
	return (style.display === 'none')
}

export {wrap, addClass, removeClass, hasClass, removeElement, getDataAttributes, getElementPosition, isHidden};
